import React, { useState, useEffect } from 'react';

const TVInstructions: React.FC = () => {
  const [showInstructions, setShowInstructions] = useState(false);
  const [isSmartTV, setIsSmartTV] = useState(false);

  useEffect(() => {
    // Check if running on smart TV
    const smartTV = document.body.classList.contains('smart-tv');
    setIsSmartTV(smartTV);
    
    // Show instructions briefly on smart TV
    if (smartTV) {
      setShowInstructions(true);
      const timer = setTimeout(() => {
        setShowInstructions(false);
      }, 5000); // Hide after 5 seconds
      
      return () => clearTimeout(timer);
    }
  }, []);

  if (!isSmartTV || !showInstructions) {
    return null;
  }

  return (
    <div className="tv-instructions">
      <div className="instructions-content">
        <h3>Smart TV Controls</h3>
        <div className="instructions-grid">
          <div className="instruction-item">
            <span className="key">← →</span>
            <span className="action">Navigate</span>
          </div>
          <div className="instruction-item">
            <span className="key">Enter</span>
            <span className="action">Play/Pause</span>
          </div>
          <div className="instruction-item">
            <span className="key">Back</span>
            <span className="action">Settings</span>
          </div>
        </div>
        <button 
          className="close-instructions"
          onClick={() => setShowInstructions(false)}
        >
          Got it!
        </button>
      </div>
    </div>
  );
};

export default TVInstructions;
